import noodleApiClient, { ApiDefinition } from '@noodleApi';

const updateSavedCart = async (body: ApiDefinition['/carts']['PUT']['body']): Promise<ApiDefinition['/carts']['PUT']['response']> => {
  const data = await noodleApiClient.put('/carts', body);
  return data.data;
};

export default updateSavedCart;